export const OFFER_PACKAGE = 'package'
export const OFFER_ADDON = 'addon'
export const ALL_OFFERS = [OFFER_PACKAGE, OFFER_ADDON] as const

export type Offer = (typeof ALL_OFFERS)[number]
